import React from 'react';

import { Stack, Link } from '@gogame/components';

import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

const UploadedByColumn = ({ row, onOpenBP }) => {
  const { isAllowBusinessPartner } = useGalleryPermissions();

  return row[CONCEPT.BUSINESS_PARTNERS]?.length && isAllowBusinessPartner ? (
    <Stack direction={'column'} spacing={0.5}>
      <Link onClick={() => onOpenBP(row[CONCEPT.BUSINESS_PARTNERS][0]?.id)}>
        {row[CONCEPT.BUSINESS_PARTNERS][0]?.name}
      </Link>
      <span>{row[CONCEPT.CREATED_BY]}</span>
    </Stack>
  ) : (
    row[CONCEPT.CREATED_BY]
  );
};
export default UploadedByColumn;
